<template>
  <div class="about-us-our-products bg--color-08">
    <div class="about-us-our-products__wrapper bg--color-01">
      <div class="about-us-our-products__container container-new">
        <span
          class="about-us-our-products__title txt txt--36px txt--height-44px txt--color-04 txt--bold"
        >
          {{ $t('aboutUs.ourProductsBlock.title') }}
        </span>

        <div class="about-us-our-products__info-column">
          <div
            :key="currentItem.title"
            class="about-us-our-products__info-column-content"
          >
            <span
              class="txt txt--26px txt--height-34px txt--color-04 txt--bold"
            >
              {{ currentItem.title }}
            </span>

            <span
              class="txt txt--16px txt--22px--m txt--height-20px txt--height-30px--m txt--color-04"
            >
              {{ currentItem.description }}
            </span>

            <exc-button
              v-if="currentItem.btn"
              :soon="currentItem.btn.soon"
              :to="currentItem.btn.to"
              class="about-us-our-products__button mt-20"
            >
              {{ currentItem.btn.title }}
            </exc-button>
          </div>
        </div>

        <div class="about-us-our-products__slider-column">
          <hooper
            ref="slider"
            :key="settingsSetter"
            infinite-scroll
            auto-play
            :settings="settings"
            :vertical="isVertical"
            :center-mode="isCenterMode"
            :wheel-control="false"
            style="height: auto"
            class="about-us-our-products__hooper slider"
            @slide="setCurrentSlide"
          >
            <slide
              v-for="(item, index) in items"
              :key="`slide--${index}-${currentSlide}`"
              :duration="5000"
              :index="index + 1"
              class="about-us-our-products__hooper--slide main-slide"
            >
              <!-- :class="
                  index === currentSlide
                    ? item.activeBgColorClass || 'bg--color-02'
                    : 'bg--color-02'
                " -->
              <client-only>
                <div v-if="!isVertical" class="about-us-our-products__slide">
                  <video
                    v-if="item.video"
                    :ref="`video-${index}`"
                    loop
                    muted
                    playsinline
                    class="crypto-academy__video"
                  >
                    <source :src="item.video" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                  <img v-else :src="item.image">
                </div>

                <about-us-products-desktop-slide
                  v-else
                  :item="item"
                  :is-active="index === currentSlide"
                  :class="{
                    'mt-32': !isCenterMode,
                  }"
                  class="about-us-our-products__desktop-slide"
                />
              </client-only>
            </slide>
          </hooper>
        </div>

        <div
          class="about-us-our-products__pagination"
          :class="{
            'is-vertical': isVertical,
          }"
        >
          <div
            v-for="(slide, index) in items"
            :key="index"
            class="about-us-our-products__pagination-item"
            :class="{
              'about-us-our-products__pagination-item--active':
                index === currentSlide,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide } from 'hooper-cnb'
import debounce from 'lodash/debounce'
import { ExcButton } from '@/components/common'

export default {
  name: 'AboutUsOurProducts',
  components: {
    Hooper,
    Slide,
    ExcButton,
    AboutUsProductsDesktopSlide: () =>
      import('@/components/about-us/elements/AboutUsProductsDesktopSlide.vue'),
  },
  data: () => ({
    currentSlide: 0,
    settingsSetter: 1,
    settings: {},
    prevIsMobile: false,
    sliderLoaded: false,
  }),
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(760)
    },
    items () {
      return [
        {
          image: require('@/assets/img/about-us/our-products/spot-tradings.svg'),
          video: '/videos/about-us/products/stop-trading.mp4',
          activeBgColorClass: 'bg--color-11',
          btn: {
            to: this.localePath('/exchange'),
          },
        },
        {
          image: require('@/assets/img/about-us/our-products/c-freezer.svg'),
          video: '/videos/about-us/products/c-freezer.mp4',
          activeBgColorClass: 'bg--color-09',
          btn: {
            to: this.localePath('/c-freezer'),
          },
        },
        {
          image: require('@/assets/img/about-us/our-products/cpex.svg'),
          video: '/videos/about-us/products/cpex.mp4',
          activeBgColorClass: 'bg--color-10',
          btn: {
            to: this.localePath('/network'),
          },
        },
        {
          image: require('@/assets/img/about-us/our-products/demo-trading.svg'),
          video: '/videos/about-us/products/demo-trading.mp4',
          activeBgColorClass: 'bg--color-11',
          btn: {
            to: this.localePath('/demo-exchange'),
            soon: true,
          },
        },
        {
          image: require('@/assets/img/about-us/our-products/levels.svg'),
          video: '/videos/about-us/products/levels.mp4',
          activeBgColorClass: 'bg--color-09',
          btn: {
            to: this.localePath('/user/ticket'),
            soon: false,
          },
        },

        {
          image: require('@/assets/img/about-us/our-products/crypto-campus.svg'),
          video: '/videos/about-us/products/campus.mp4',
          activeBgColorClass: 'bg--color-10',
          btn: {
            to: this.localePath('/crypto-campus'),
            soon: false,
          },
        },

        {
          image: require('@/assets/img/about-us/our-products/referals.svg'),
          video: '/videos/about-us/products/referrals.mp4',
          activeBgColorClass: 'bg--color-11',
          btn: {
            to: this.localePath('/user/referrals'),
          },
        },

        {
          image: require('@/assets/img/about-us/our-products/launchpad.svg'),
          video: '/videos/about-us/products/launchpad.mp4',
          activeBgColorClass: 'bg--color-09',
          btn: {
            to: this.localePath('/launchpad'),
            soon: true,
          },
        },
      ].map((item, index) => {
        item.title = this.$t(`aboutUs.ourProductsBlock.items.${index}.title`)
        item.description = this.$t(
          `aboutUs.ourProductsBlock.items.${index}.description`,
        )

        if (item.btn) {
          item.btn.title = this.$t(
            `aboutUs.ourProductsBlock.items.${index}.btnText`,
          )
        }

        return item
      })
    },
    currentItem () {
      return this.items[this.currentSlide] || this.items[0]
    },
    isVertical () {
      return this.$mq?.resize && this.$mq?.above(1366)
      // return this.$mq?.resize && this.$mq?.above(768)
    },
    isCenterMode () {
      return this.$mq?.resize && this.$mq?.above(1366)
    },
  },
  watch: {
    currentSlide: {
      immediate: true,
      handler (slideIndex, prevSide) {
        if (!process.client) return
        if (this.isVertical) return

        const _handle = () => {
          const prevSliders = this.$refs[`video-${prevSide}`]
          if (prevSliders) {
            prevSliders.forEach((prevSlider) => {
              prevSlider.pause()
              prevSlider.currentTime = 0
            })
          }

          const currentSliders = this.$refs[`video-${slideIndex}`]
          if (currentSliders) {
            currentSliders.forEach(currentSlider => currentSlider.play())
          }

          this.sliderLoaded = true
        }

        if (!this.sliderLoaded) setTimeout(_handle, 400)
        else _handle()
      },
    },
    isVertical () {
      this.setSettings(true)
    },
  },
  created () {
    this.setSettings(false)

    if (process.client) {
      this.$watch(
        '$mq.resize',
        debounce(() => this.setSettings(false), 300),
      )
      // debugger
    }
  },
  mounted () {
    window.dispatchEvent(new Event('resize'))
    // window.slider = this.$refs.slider
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.$watch(() => {
    //       return this.$refs.slider.isDragging
    //     }, (v) => {
    //       if (v) this.disableScrolling()
    //       else this.enableScrolling()
    //     })
    //   }, 300)
    // })
    // this.settingsSetter++
  },
  methods: {
    setCurrentSlide (payload) {
      const firstIndex = 0
      const lastIndex = this.items.length - 1

      const selectedIndex = payload.currentSlide

      if (selectedIndex > lastIndex) this.currentSlide = firstIndex
      else if (selectedIndex < firstIndex) this.currentSlide = lastIndex
      else this.currentSlide = selectedIndex
    },
    setSettings (reRenderSlider = true) {
      // only from tablet/pc to mobile and from only from mobile to another device (resize)
      if (this.isMobile) {
        if (this.prevIsMobile) return
        this.prevIsMobile = true
      } else {
        this.prevIsMobile = false
      }

      // console.log('set slider bp settings...', reRenderSlider)

      this.settings = {
        breakpoints: generateBreakpoints(this.isVertical, this.$mq?.below(991)),
      }
      if (reRenderSlider) this.settingsSetter++
    },

    // disableScrolling () {
    //   document.body.style.overflow = 'hidden'
    // },

    // enableScrolling () {
    //   document.body.style.overflow = 'auto'
    // },
  },
}

function generateBreakpoints (isVertical) {
  const cardWidth = isVertical ? 380 : 300
  const bps = {}

  let bp = isVertical ? cardWidth * 1.5 : 2850 / 2
  // const spacing = isMobile ? 24 : 20
  const step = 40

  while (bp > 10) {
    const value = (bp - step) / cardWidth
    const t = isVertical ? 1 : 1.1
    bps[bp * t] = {
      itemsToShow: bp < 420 ? 1.1 : bp < 450 ? 1.25 : bp < 500 ? 1.4 : value,
    }
    // bps[bp] = { itemsToShow: value < 1.04 ? 1.04 : value }
    bp = bp - step
  }

  return bps
}
</script>

<style lang="scss">
// body:has(.hooper-track.is-dragging) {
//   @include bp(m) {
//     overflow-y: hidden !important;
//   }

//   @include bp(1300px) {
//     overflow-y: unset;
//   }
// }
</style>

<style lang="scss" scoped>
.about-us-our-products {
  max-width: 100vw;
  overflow-x: hidden;

  // touch-action: pan-x pan-y;
  // scroll-snap-type: x mandatory;
  // scroll-snap-align: center;
  // scroll-behavior: smooth;

  &__wrapper {
    padding: toRem(20px) 0;
    border-radius: toRem(20px);
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    max-width: 100%;

    @include bp(1366px) {
      padding: 0;
    }

    @include bp(l) {
      // padding: toRem(60px) 0;
      border-radius: toRem(60px);
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto toRem(10px) minmax(150px, 1fr);
    gap: toRem(24px);
    grid-template-areas:
      'title'
      'slider'
      'pagination'
      'info';

    @include bp(1366px) {
      min-height: calc(380px * 1.5);
      grid-template-rows: unset;
      grid-template-areas: 'pagination slider';
      grid-template-columns: toRem(10px) 1fr;
      align-items: center;
      gap: toRem(48px);
    }
  }

  &__button {
    max-width: fit-content;
  }

  &__slider-column {
    grid-area: slider;
    position: relative;
    max-width: calc(100vw - 20px);

    @include bp(1366px) {
      justify-self: flex-end;
      max-width: unset;

      &,
      .slider {
        height: 100% !important;
      }
    }
  }

  &__slide {
    width: toRem(300px);
    height: toRem(300px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // padding: toRem(24px);
    border-radius: toRem(20px);
    transition-duration: 0.25s;

    img {
      max-width: 100%;
    }

    video {
      max-width: toRem(300px);
    }

    @include bp(420px) {
      width: toRem(340px);
      height: toRem(340px);

      video {
        max-width: toRem(340px);
      }
    }

    // @include bp(440px) {
    //   width: toRem(340px);
    //   height: toRem(340px);
    // }

    @include bp(768px) {
      width: toRem(310px);
      height: toRem(310px);

      video {
        max-width: toRem(310px);
      }
    }

    @include bp(1366px) {
      display: none;
      // height: toRem(340px);
      // width: toRem(340px);
    }

    // @include bp(824px) {
    //   height: toRem(380px);
    //   width: toRem(380px);
    // }
  }

  &__desktop-slide {
    display: none;

    @include bp(1366px) {
      display: block;
    }
  }

  &__title {
    grid-area: title;

    @include bp(1366px) {
      display: none;
    }
  }

  &__info-column {
    grid-area: info;
    display: flex;
    flex-direction: column;
    gap: toRem(40px);

    @include bp(1366px) {
      display: none;
    }

    &-title {
      display: none;

      @include bp(1366px) {
        display: block;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: toRem(8px);
      max-width: calc(100vw - 40px);
      align-self: flex-start;

      @include bp(1366px) {
        max-width: unset;
        align-self: unset;
      }
    }
  }

  &__pagination {
    grid-area: pagination;
    display: flex;
    gap: toRem(7px);
    align-items: center;
    justify-content: center;

    &:not(.is-vertical) {
      height: toRem(10px);
    }

    &.is-vertical {
      width: toRem(10px);
      flex-direction: column;
    }
  }

  &__pagination-item {
    width: toRem(6px);
    height: toRem(6px);
    background: #d1d1d1;
    border-radius: 50%;
    transition: 0.2s;

    &--active {
      width: toRem(10px);
      height: toRem(10px);
      background: color('color-05');
    }
  }
}
</style>
